"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderToken = void 0;
var react_1 = __importDefault(require("react"));
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var MakeSharedRenderProps_1 = require("../TokenRenderers/MakeSharedRenderProps");
var PublicStyleContext_1 = require("./PublicStyleContext");
var tokenToReactComponent_1 = require("../TokenRenderers/tokenToReactComponent");
var RenderToken = function (_a) {
    var token = _a.token, childTokens = _a.childTokens;
    var _b = (0, PublicStyleContext_1.usePublicStyleContext)(), blockStyles = _b.blockStyles, colorProvider = _b.colorProvider;
    var config = (0, GetCommonConfigByType_1.getGenericCommonConfigByType)(token.subType);
    if (config) {
        if (!config.publicRenderReactNode) {
            throw new Error("Widget ".concat(token.subType, " does not support React rendering"));
        }
        var props = (0, MakeSharedRenderProps_1.makeSharedRenderProps)(token, {
            blockStyles: blockStyles,
            colorProvider: colorProvider,
        });
        return react_1.default.createElement(react_1.default.Fragment, null, config.publicRenderReactNode(__assign(__assign({}, props), { childTokens: childTokens })));
    }
    var ReactComponent = tokenToReactComponent_1.tokenToReactComponent.get(token.subType);
    if (ReactComponent) {
        return react_1.default.createElement(ReactComponent, { token: token, childTokens: childTokens });
    }
    throw new Error("No React component found for token ".concat(token.subType));
};
exports.RenderToken = RenderToken;
